import type { SenseContext } from '@shared/types';

type RawContext = Record<string, unknown>;

const text = (value: unknown): string | null =>
  typeof value === 'string' && value.trim() ? value : null;

/** Контексты смысла из ответа API (2026-09-25): другие употребления слова с тем же
 *  переводом. REST отдаёт snake_case, SSE — camelCase; принимаем оба. */
export function mapSenseContexts(raw: unknown): SenseContext[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((c): c is RawContext => typeof c === 'object' && c !== null)
    .map((c) => ({
      exampleEn: text(c.example_en ?? c.exampleEn),
      simpleExampleEn: text(c.simple_example_en ?? c.simpleExampleEn),
      hint: text(c.hint),
      definition: text(c.definition),
    }))
    .filter((c) => c.exampleEn || c.simpleExampleEn);
}
